import { useEffect, useLayoutEffect, useRef, useState } from 'react';

export function useCalendarPopover() {
    const [openCalendar, setOpenCalendar] = useState(false);
    const calendarRef = useRef<HTMLDivElement | null>(null);
    const mobileCalendarRef = useRef<HTMLDivElement | null>(null);
    const checkInRef = useRef<HTMLDivElement | null>(null);
    const [calendarPos, setCalendarPos] = useState<{
        top: number;
        left: number;
    }>({ top: 0, left: 0 });

    const updateCalendarPos = () => {
        if (checkInRef.current) {
            const rect = checkInRef.current.getBoundingClientRect();
            const calendarWidth = 672; // max-w-2xl
            const left = Math.max(8, (window.innerWidth - calendarWidth) / 2);
            // Stick to top-5 (20px) when the trigger scrolls above the viewport
            const top = Math.max(88, rect.bottom + 4);
            setCalendarPos({ top, left });
        }
    };

    useLayoutEffect(() => {
        if (openCalendar) {
            updateCalendarPos();
        }
    }, [openCalendar]);

    useEffect(() => {
        if (!openCalendar) return;
        window.addEventListener('scroll', updateCalendarPos, true);
        window.addEventListener('resize', updateCalendarPos);
        return () => {
            window.removeEventListener('scroll', updateCalendarPos, true);
            window.removeEventListener('resize', updateCalendarPos);
        };
    }, [openCalendar]);

    return {
        openCalendar,
        setOpenCalendar,
        calendarRef,
        mobileCalendarRef,
        checkInRef,
        calendarPos,
    };
}
